// Libs
import React, { ReactNode, ElementRef, RefObject } from 'react';
import classNames from 'classnames';

// Hooks
import { useTranslation } from '@external/react-i18next';

// Components
import { Icon } from '@components/Icon';
import CustomContextMenu from '@components/CustomContextMenu';

interface Props {
  filters: ReactNode;
  showFiltersInContextMenu: boolean | undefined;
  contextMenuTitle: string;
  handleFilters: () => void;
  customContextMenuRef: RefObject<ElementRef<typeof CustomContextMenu>>;
  className?: string;
}

const MobileFilter = ({
  filters,
  handleFilters,
  showFiltersInContextMenu,
  contextMenuTitle,
  customContextMenuRef,
  className,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(className, 'desktop:hidden')}>
      <button
        onClick={handleFilters}
        className="flex items-center tap-highlight-color-transparent"
      >
        <Icon name="ui/filter" className="inline-block mr-3" />
        <span>{t('filter', 'Filter')}</span>
      </button>
      {showFiltersInContextMenu && (
        <CustomContextMenu ref={customContextMenuRef} title={contextMenuTitle}>
          {filters}
        </CustomContextMenu>
      )}
    </div>
  );
};

export default MobileFilter;
